import { AngularAdapter } from './classes/angular-adapter';
import { EventEmitter } from './classes/event-emitter';
import { DataProviderFactory } from './data-provider/data-provider-factory';
import { ValueStorageProvider } from './services/storage';

import { EventCollectorService } from './services/eventCollector';
import { SysAsyncService } from './services/async';
import './services/async-service';
import { AsyncComponentComponent } from './directives/asyncComponent';
import { AsyncChunkComponent } from './directives/asyncChunk';
import { SysDebugComponent } from './directives/debug';
import { TranscludeReplaceComponent } from './directives/transclude-replace';

export const adapter = new AngularAdapter();

/**
 * Export some classes to use in es5 modules
 * @type {Object}
 */

(window as any).a9 = {
    EventEmitter: EventEmitter
};

adapter.linkService(EventCollectorService);
adapter.linkService(SysAsyncService);
adapter.linkDirective(AsyncComponentComponent);
adapter.linkDirective(AsyncChunkComponent);
adapter.linkDirective(SysDebugComponent);
adapter.linkDirective(TranscludeReplaceComponent);
adapter.linkService(DataProviderFactory);
adapter.linkProvider(ValueStorageProvider);

// export * bug - https://github.com/babel/babel/issues/2877
export { A9Component, A9Service } from './angular';
export { AngularInjector } from './angular/AngularInjector';
export {
    AbstractSelection,
    ComponentController,
    Controller,
    Directive,
    EventEmitter,
    Filter,
    Provider,
    Service,
    type ICancelListener,
    type IComponentControllerScope,
    type IEventEmitter,
    type IListener
} from './classes';
export {
    AbstractCollectionDataProvider,
    AbstractDataProvider,
    AbstractDataProviderV2,
    ActionTypes,
    ApiError,
    BaseDataProvider,
    CollectionResource,
    DataProvider,
    DataProviderFactory,
    Events,
    ItemResource,
    Resource,
    SimpleDataProvider,
    type IAction,
    type IActiveSorting,
    type IBaseDataProvider,
    type ICollectionParams,
    type IDataProvider,
    type IDataProviderHelper,
    type IDataProviderV2,
    type IFilter,
    type IHttpDataService,
    type IItem,
    type IList,
    type IPagination,
    type IPartialItem,
    type IRequestResult,
    type IResourceEvent,
    type IResourceParams,
    type ISorting,
    type PartialType
} from './data-provider';
export { getDisplayErrorHandler, getGeneralHandler } from './helpers/errorHandlers';
